export default {
  API_ENDPOINT: 'https://safe-atoll-23344.herokuapp.com',
  API_KEY: process.env.REACT_APP_API_KEY,
}